import CloseIcon from "@mui/icons-material/Close";
import {
  Autocomplete,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { ReactComponent as FilterIcon } from "../../../src/assets/Customer/FilterIcon.svg";
import { ReactComponent as FilterIconHover } from "../../../src/assets/Customer/FilterIconHover.svg";
import CancelButtons from "../../components/DialogBoxComponent/CancelButtons";
import SubmitButtons from "../../components/DialogBoxComponent/SubmitButtons";
import Toast from "../../components/ToastContainer/CustomToast";
import { getPurposeType } from "../../slices/PurposeTypeGlobalUSA/PurposeTypeGlobalSlice";
import { listVisitorTypeZlink } from "../../slices/PurposeTypeUSA/PurposeTypeUSASlice";
import { getAllVisitorType } from "../../slices/VisitorType/VisitorTypeSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import CommonUtil from "../../Util/CommonUtils";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function FilterBlockedVisitors(props) {
  const [open, setOpen] = React.useState(false);
  const [data, setData] = useState();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [visitorData, setVisitorData] = useState([]);
  const { darkMode, setDiaLogBoxBlur } = useContext(ThemeContext);
  const [purposeData, setPurposeData] = useState([]);
  const [isHovered, setIsHovered] = useState(false);
  const [payload, setPayload] = useState({
    purposeTypeId: "",
    visitorTypeId: "",
    status: props.status,
    visitMode: props.selectedObject,
  });

  const [selectedPurpose, setSelectedPurpose] = useState(null);
  const [selectedVisitor, setSelectedVisitor] = useState(null);

  const handleClose = () => {
    setPayload({
      purposeTypeId: "",
      visitorTypeId: "",
      status: props.status,
      visitMode: props.selectedObject,
    });
    setSelectedPurpose(null);
    setSelectedVisitor(null);
    setOpen(false);
    setDiaLogBoxBlur(false);
  };

  if (open) {
    setDiaLogBoxBlur(true);
  }
  const [error, setError] = useState({
    purposeTypeId: false,
    visitorTypeId: false,
  });

  const onselectPurposeType = (event) => {
    setPayload({
      ...payload,
      purposeTypeId: event,
    });
  };

  const loadPurposeType = () => {
    const query = {
      page: 1,
      rowsPerPage: 1000,
      name: "",
      status: "ACTIVE",
    };

    dispatch(getPurposeType(query))
      .unwrap()
      .then((data) => {
        if (data.code === "CVAI0000") {
          setPurposeData(data.data.purposeTypes);
        } else {
          setPurposeData([]);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const reset = () => {
    setOpen(false);
  };

  const handleChange = (event) => {
    const name = event.target.name;
    setPayload({
      ...payload,
      [name]: event.target.value,
    });

    setError({
      [name]: false,
    });
  };

  const handleSubmit = () => {
    if (payload.purposeTypeId === "" && payload.visitorTypeId === "") {
      Toast(t("COMMON015"), "error");
      return;
    }

    props.applyFilter(payload);
    setPayload({
      purposeTypeId: "",
      visitorTypeId: "",
      visitMode: props.selectedObject,
      status: props.status,
    });
    handleClose();
  };

  const loadData = () => {
    loadVisitorType();
    loadPurposeType();
  };

  const loadVisitType = () => {
    const query = {
      id: "",
      name: "",
      pageNumber: 1,
      pageSize: 0,
      isPageable: true,
    };

    dispatch(listVisitorTypeZlink(query))
      .unwrap()
      .then((data) => {
        if (data.code === "CVAI0000") {
          setData(data.data.purposeTypes);
        } else {
          setData([]);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const loadVisitorType = () => {
    const query = {
      page: 1,
      rowsPerPage: 1000,
      name: "",
      status: "ACTIVE",
    };

    dispatch(getAllVisitorType(query))
      .unwrap()
      .then((data) => {
        if (data.code === "CVAI0000") {
          setVisitorData(data.data.visitorTypes);
        } else {
          setVisitorData([]);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const selectedPurposeType = (newValue) => {
    if (newValue != null) {
      setPayload({
        ...payload,
        purposeTypeId: newValue.id,
      });
    } else {
      setPayload({
        ...payload,
        purposeTypeId: "",
      });
    }
  };

  const selectedVisitorType = (newValue) => {
    if (newValue != null) {
      setPayload({
        ...payload,
        visitorTypeId: newValue.id,
      });
    } else {
      setPayload({
        ...payload,
        visitorTypeId: "",
      });
    }
  };

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("darkMode");
    } else {
      document.body.classList.remove("darkMode");
    }
    return () => {
      document.body.classList.remove("darkMode");
    };
  }, [darkMode]);

  return (
    <>
      {/* <Tooltip title={<Typography>{t("COMMON006")}</Typography>}>
        <Box
          className={
            darkMode ? "filterIconContainerDark" : "filterIconContainer"
          }
        >
          <FilterIcon
            onClick={() => {
              setOpen(true);
              loadData();
            }}
            className={darkMode ? "custom-icon" : ""}
            style={{ cursor: "pointer" }}
          >
            <FilterBlockedVisitors />
          </FilterIcon>
        </Box>
      </Tooltip> */}
      <Tooltip
        title={
          <Typography fontSize={12} fontWeight={500}>
            {t("COMMON006")}
          </Typography>
        }
      >
        <span
          className={darkMode ? "filterdark" : "filter"}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={() => {
            setOpen(true);
            loadData();
          }}
        >
          {isHovered ? (
            <FilterIconHover
              style={{
                cursor: "pointer",
                color: darkMode ? "#fff" : "#474a4e",
              }}
            >
              <FilterBlockedVisitors />
            </FilterIconHover>
          ) : (
            <FilterIcon
              style={{
                cursor: "pointer",
                color: darkMode ? "#fff" : "#474a4e",
              }}
            >
              <FilterBlockedVisitors />
            </FilterIcon>
          )}
        </span>
      </Tooltip>
      <Grid item xs={6}>
        <Dialog
          open={open}
          fullWidth={true}
          disableBackdropClick
          disableEscapeKeyDown
          BackdropProps={{
            style: {
              backdropFilter: "blur(5px)",
              // Adjust the opacity as needed
            },
          }}
        >
          <DialogTitle
            variant="h4"
            style={{ backgroundColor: darkMode ? "#0E2A41" : "#fff" }}
          >
            <IconButton
              onClick={handleClose}
              aria-label="close"
              sx={{
                position: "absolute",
                right: 15,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>

            <Typography
              style={{ fontSize: "21px", color: darkMode ? "#fff" : "black" }}
            >
              {t("COMMON006")}
            </Typography>
          </DialogTitle>
          <Divider variant="middle" />
          <DialogContent
            style={{
              backgroundColor: darkMode ? "#0E2A41" : "#fff",
              paddingBottom: "8px",
            }}
          >
            <Grid
              container
              spacing={2}
              justifyContent="center"
              alignItems={"center"}
            >
              <Grid item xs={12} sm={12}>
                <Autocomplete
                  popupIcon={<ExpandMoreIcon />}
                  fullWidth
                  noOptionsText={"No Options found"}
                  options={
                    CommonUtil.isEmptyArray(purposeData) ? [] : purposeData
                  }
                  getOptionLabel={(option) => (option.name ? option.name : "")}
                  value={selectedPurpose}
                  onChange={(event, newValue) => {
                    setSelectedPurpose(newValue);
                    selectedPurposeType(newValue);
                    setError({ purposeTypeId: false });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={t("PURPOSETYPE")}
                      required={false}
                      palceholder="PurposeType"
                      name="id"
                      error={error.purposeTypeId}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={12}>
                <Autocomplete
                  popupIcon={<ExpandMoreIcon />}
                  fullWidth
                  noOptionsText={"No Options found"}
                  options={visitorData}
                  getOptionLabel={(option) => (option.name ? option.name : "")}
                  value={selectedVisitor}
                  onChange={(event, newValue) => {
                    setSelectedVisitor(newValue);
                    selectedVisitorType(newValue);
                    setError({ visitorTypeId: false });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={t("COMMON068")}
                      required={false}
                      palceholder="Visitor Type"
                      name="id"
                      error={error.visitorTypeId}
                    />
                  )}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions
            style={{
              justifyContent: "center",
              backgroundColor: darkMode ? "#0E2A41" : "#fff",
            }}
          >
            <CancelButtons
              variant="contained"
              color="secondary"
              onClick={handleClose}
            >
              <Typography variant="body1" style={{ textTransform: "none" }}>
                {t("INVITATION003")}
              </Typography>
            </CancelButtons>
            <SubmitButtons variant="contained" onClick={handleSubmit}>
              <Typography variant="body1" style={{ textTransform: "none" }}>
                {t("COMMON024")}
              </Typography>
            </SubmitButtons>
          </DialogActions>
        </Dialog>
      </Grid>
    </>
  );
}
